const formatCep = value => {
  if (!value) return null;
  const matchFormat = value.replace(/\s/g, '').match(/\d{3,5}/g);
  const result = matchFormat ? matchFormat.join('-').substr(0, 9) : null;
  return /[0-9]{5}-?[\d]{3}/.test(result) ? result : value;
};

export { formatCep };
